<template>
  <el-card>
    <template #header>
      <h4>{{ $t('用户中心') }}</h4>
    </template>

    <el-row v-for="(l1, index) in rowData" :key="index">
      <el-col v-for="(item, lIndex) in l1" :key="lIndex" :span="4">
        <div class="item">
          <span>{{ $t(item.name) }}</span>
          <span class="count">{{ data[item.key] || 0 }}</span>
        </div>
      </el-col>
    </el-row>

  </el-card>
</template>

<script>
export default {
  name: "UserStat",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: [
        [
            { name: '普通用户数量', count: 300, key: "normalUserCount"  },
            { name: '会员数量', count: 300, key: "vipUserCount" },
            { name: '充值会员数量', count: 300, key: "payVipUserCount" },
            { name: '激活会员数量', count: 300, key: "activateVipUserCount" },
            { name: '用户总量', count: 300, key: "allUserCount" },
        ],
        [
          { name: '当前在线人数', count: 300, key: "onlineUserCount" },
          { name: '今日推广用户量', count: 300, key: "todayPromoteCount" },
          { name: '今日注册用户量', count: 300, key: "todayRegisterCount" },
        ],
        [
          { name: '今日实名用户量', count: 300, key: "todayNameUserCount" },
          { name: '实名用户总量', count: 300, key: "nameUserCount" },
          { name: '今日连接硬件', count: 300, key: "todayLinkCount" },
          { name: '连接硬件总数', count: 300, key: "allLinkCount" },
        ],
      ]

    }
  }
}
</script>

<style scoped>

.el-row {
  margin-bottom: 50px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
}

.count {
  font-weight: 600;
  font-size: 20px;
}

</style>
